"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.onComplete = exports.send = void 0;
var send_1 = require("./send");
Object.defineProperty(exports, "send", { enumerable: true, get: function () { return send_1.send; } });
var onComplete_1 = require("./onComplete");
Object.defineProperty(exports, "onComplete", { enumerable: true, get: function () { return onComplete_1.onComplete; } });
